import React from 'react'
import dayjs from 'dayjs'

// types
import { Pass } from '../../../../types/types'

// utils
import { DATE_FORMAT } from '../../../../utils/enums'

// hooks
import useMessages from '../../../../hooks/useMessages'

// styles
import * as SC from './PassCardStyles'

type PassCardProps = {
	pass: Pass
	href: string
	cardStyle?: 'active' | 'past'
}

export const PassCardSkeleton = () => {
	return <SC.PassCardSkeleton width='100%' height='148px' animated />
}

const PassCard = (props: PassCardProps) => {
	const { pass, href, cardStyle = 'active' } = props
	const { messages } = useMessages()

	return (
		<SC.PassCardLink href={href} $isPast={cardStyle === 'past'}>
			<SC.PassCardHeader>
				<SC.ServiceName>{pass.serviceName}</SC.ServiceName>
				{pass.salon.name && <SC.SalonName>{pass.salon.name}</SC.SalonName>}
			</SC.PassCardHeader>
			<SC.PassCardFooter>
				<SC.PassCardFooterColumn>
					<SC.PassCardLabel>{messages['Expires on']}</SC.PassCardLabel>
					<SC.PassCardValue>{dayjs(pass.expiresAt).format(DATE_FORMAT)}</SC.PassCardValue>
				</SC.PassCardFooterColumn>
				<SC.PassCardFooterColumn $align='right'>
					<SC.PassCardLabel>{messages['Entries used']}</SC.PassCardLabel>
					<SC.PassCardValue>
						{pass.usedEntries}/{pass.totalEntries}
					</SC.PassCardValue>
				</SC.PassCardFooterColumn>
			</SC.PassCardFooter>
		</SC.PassCardLink>
	)
}

export default PassCard
